import(/* webpackMode: "eager" */ "/home/interim/frontend/app/services/outsourcing-functions/page.tsx");
